import { Hero, Stage, DraftOptions, DefaultDraftOptions } from "draft/types";


export interface Tournament {
    Id : string,
    Name: string,
    CreatedAt : Date,
    DraftOptions : DraftOptions,
    GroupStageGames :Game[],
    MatchesPrHeat : number,
    Players: Participant[]
}

export const EmptyTournament = () : Tournament => {
    var tour : Tournament = {
        Id: "",
        Name: "",
        DraftOptions : DefaultDraftOptions(),
        CreatedAt: new Date(),
        GroupStageGames: [],
        MatchesPrHeat : 1,
        Players: []
    }
    return tour;
}

export interface Game {
    Id:string,
    TournamentId : string,
    Name?:string,
    Players: Participant[],
    TeamBlue: Participant[],
    TeamRed: Participant[],
    Winners : Participant[],
    Stage? : Stage,
    StockDifference?: number,
    Heat? : number
}

export const gameToTrackData = (game:Game, tournament:Tournament) => {
    let drafted = false;
    let teamBlue : any = []
    game.TeamBlue.forEach(p => {
        if(p.Hero != null){
            drafted = true;
        }
        teamBlue.push({
            "name" : p.Name,
            "hero" : p.Hero?.Name
        })
    })

    let teamRed : any = []
    game.TeamRed.forEach(p => {
        teamRed.push({
            "name" : p.Name,
            "hero" : p.Hero?.Name
        })
    })

    let winners : String[] = []
    game.TeamRed.forEach(p => { winners.push(p.Name) })

    return {
        "id" : game.Id,
        "tournamentGame" : tournament.Name,
        "tournamentId" : game.TournamentId,
        "gameName" : game.Name,
        "drafted" : drafted,
        "stage" : game.Stage?.Name,
        "teamBlue" : teamBlue,
        "teamRed" : teamRed,
        "winners" : winners,
        "stockDifference" : game.StockDifference
    }
}

export interface Participant{
    Number: number;
    Name: string;
    Wins: number;
    StockDifference: number,
    GamesPlayed : number,
    Hero?: Hero
    GenData? : GenData
}

type GenData = {
    assignedGames : number
    teamTable : {}
    occuranceTable : {}
}

export interface TourConfig{
    EditKey?: string,
}

export interface MetaData{
    generationScore : number,
}